import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from 'axios';
import VueSession from 'vue-session';
import VueSimpleAlert from "vue-simple-alert";

Vue.prototype.$http = axios;
Vue.config.productionTip = false;

// axios.defaults.baseURL = 'https://ozitcloud.com/pizza/api';

Vue.use(axios);
Vue.use(VueSession);
Vue.use(VueSimpleAlert);
window.Event = new Vue();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
